import api from 'api';
import DesignItem from 'records/DesignItem';

export const DESIGN_ITEM_ASYNC_ACTION_START = 'DESIGN_ITEM_ASYNC_ACTION_START';
export const DESIGN_ITEM_ASYNC_ACTION_ERROR = 'DESIGN_ITEM_ASYNC_ACTION_ERROR';
export const DESIGN_ITEM_ASYNC_ACTION_SUCCESS = 'DESIGN_ITEM_ASYNC_ACTION_SUCCESS';
export const DESIGN_ITEM_UPDATE_ACTION_SUCCESS = 'DESIGN_ITEM_UPDATE_ACTION_SUCCESS';
export const DESIGN_ITEM_RESET_STATE = 'DESIGN_ITEM_RESET_STATE';
export const DESIGN_ITEM_ASYNC_ACTION_SUCCESS_WITHOUT_DATA='DESIGN_ITEM_ASYNC_ACTION_SUCCESS_WITHOUT_DATA';

function designItemAsyncActionStart() {
  return {
    type: DESIGN_ITEM_ASYNC_ACTION_START,
  };
}

function designItemAsyncActionError(error) {
  return {
    type: DESIGN_ITEM_ASYNC_ACTION_ERROR,
    error,
  };
}

function designItemAsyncUpdateSuccess(data) {
  return {
    type: DESIGN_ITEM_ASYNC_ACTION_SUCCESS,
    data,
  };
}
function designItemAsyncActionSuccWithoutData() {
  return {
    type: DESIGN_ITEM_ASYNC_ACTION_SUCCESS_WITHOUT_DATA,
  };
}

export function updateDesignItem(data) {
  return {
    type: DESIGN_ITEM_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function resetDesignItemState() {
  return {
    type: DESIGN_ITEM_RESET_STATE,
  };
}

export function updateDesignItemAsync(designItem) {
  return (dispatch, getState) => {
    dispatch(designItemAsyncActionStart());
    return api.request('designitem', 'put', designItem)
    .then((data) => {
      dispatch(designItemAsyncUpdateSuccess(data));
      return new DesignItem(data);
    })
    .catch((err) => {
      dispatch(designItemAsyncActionError('Unable to update design item'));
      throw (err);
    });
  };
}

export function syncImpactedDesigns(menuItemId, userCategoryId) {
  return (dispatch, getState) => {
    dispatch(designItemAsyncActionStart());
    return api.request(`designitem/sync?menuItemId=${menuItemId}&menuItemUserCategoryId=${userCategoryId!=undefined?userCategoryId:-1}`, 'put', '')
    .then((data) => {
      dispatch(designItemAsyncActionSuccWithoutData());
    })
    .catch((err) => {
      dispatch(designItemAsyncActionError('Unable to sync Impacted Designs'));
      throw (err);
    });
  };
}
